import { createFileRoute } from '@tanstack/react-router'
import { MainPage } from 'features/main'
import { InterviewStageEnum } from 'consts/company-alias.consts'
import { InterviewFinishInitiator } from 'api/endpoints/openapi-generated.schemas'

export type QueryParams = SokolovQueryParams

export type SokolovQueryParams = {
  stage?: InterviewStageEnum
  initiator?: InterviewFinishInitiator
  reset?: boolean
}

export const Route = createFileRoute('/$companyAlias/$positionAlias/')({
  component: () => <MainPage />,
  validateSearch: (params: Record<string, string | boolean>): QueryParams => {
    return {
      stage: params.stage as SokolovQueryParams['stage'],
      initiator: params.initiator as InterviewFinishInitiator,
      reset: params.reset as boolean
    }
  }
})
